import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Page, EmptyState } from '@shopify/polaris';

import AppLayout from '../components/AppLayout';

function NotFound() {
  const navigate = useNavigate();
  
  return (
    <AppLayout>
      <Page title="Page Not Found">
        <EmptyState
          heading="Page not found"
          action={{
            content: 'Go to Dashboard',
            onAction: () => navigate('/app'),
          }}
          image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
        >
          <p>The page you're looking for doesn't exist.</p>
        </EmptyState>
      </Page>
    </AppLayout>
  );
}

export default NotFound;
